import { useTranslations } from "use-intl";

/**
 * Infographic: a week of vehicle hire with two booked blocks either side of an
 * idle gap, with a gap rental (emerald vehicle) slotted into the gap.
 */
export function GapRentalGraphic() {
  const t = useTranslations("relocation.gapRentalInfo");

  const slots = [
    { booked: true },
    { booked: true },
    { booked: false },
    { booked: false },
    { booked: true },
    { booked: true },
    { booked: true },
  ];

  const startX = 48;
  const slotW = 52;
  const slotGap = 10;
  const slotY = 56;
  const slotH = 46;

  const slotX = (i: number) => startX + i * (slotW + slotGap);
  const gapX = slotX(2);
  const gapW = slotW * 2 + slotGap;
  const gapCenter = gapX + gapW / 2;

  return (
    <div className="rounded-xl bg-gray-50 p-4">
      <svg
        viewBox="0 0 520 150"
        className="w-full"
        role="img"
        aria-label={t("subtitle")}
      >
        {/* Booked / idle blocks */}
        {slots.map((slot, i) =>
          slot.booked ? (
            <g key={i}>
              <rect
                x={slotX(i)}
                y={slotY}
                width={slotW}
                height={slotH}
                rx={8}
                fill="#e2e8f0"
              />
              <rect
                x={slotX(i) + 12}
                y={slotY + 14}
                width={slotW - 24}
                height={4}
                rx={2}
                fill="#94a3b8"
              />
              <rect
                x={slotX(i) + 12}
                y={slotY + 24}
                width={slotW - 30}
                height={4}
                rx={2}
                fill="#cbd5e1"
              />
            </g>
          ) : null,
        )}

        {/* The gap, filled by a gap rental */}
        <rect
          x={gapX}
          y={slotY}
          width={gapW}
          height={slotH}
          rx={8}
          fill="#ecfdf5"
          stroke="#10b981"
          strokeWidth={2}
          strokeDasharray="5 4"
        />

        {/* Vehicle sitting in the gap */}
        <g>
          <rect
            x={gapCenter - 30}
            y={slotY + 14}
            width={60}
            height={16}
            rx={6}
            fill="#059669"
          />
          <path
            d={`M ${gapCenter - 16} ${slotY + 14} q 4 -10 16 -10 h 6 q 8 0 12 10 z`}
            fill="#10b981"
          />
          <circle cx={gapCenter - 16} cy={slotY + 32} r={4.5} fill="#065f46" />
          <circle cx={gapCenter + 16} cy={slotY + 32} r={4.5} fill="#065f46" />
        </g>

        {/* Callout badge above the gap */}
        <g>
          <rect
            x={gapCenter - 52}
            y={14}
            width={104}
            height={26}
            rx={13}
            fill="#10b981"
          />
          <text
            x={gapCenter}
            y={31}
            textAnchor="middle"
            fontSize={13}
            fontWeight={600}
            fill="#ffffff"
          >
            {t("graphicGapLabel")}
          </text>
          <path
            d={`M ${gapCenter - 6} 40 L ${gapCenter + 6} 40 L ${gapCenter} 48 z`}
            fill="#10b981"
          />
        </g>

        {/* Caption under the row */}
        <text
          x={slotX(0) + slotW / 2}
          y={slotY + slotH + 22}
          textAnchor="middle"
          fontSize={11}
          fill="#94a3b8"
        >
          {t("graphicBookedLabel")}
        </text>
        <text
          x={gapCenter}
          y={slotY + slotH + 22}
          textAnchor="middle"
          fontSize={11}
          fontWeight={600}
          fill="#059669"
        >
          {t("graphicRentalLabel")}
        </text>
      </svg>
    </div>
  );
}
